import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const SettingsBox = styled.div`
	padding: 16px 24px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.XL}px;
`;

export { SettingsBox };
